import { toDeepFormData } from '@helpers/cast'
import axios from 'axios'
import { NOTIFICATIONS_INCLUDE } from '@store/types'
import store from '@store'

export default async (payload,
  success = 'Imagens publicadas com sucesso!',
  error = 'Não foi possível publicar as imagens.'
) => {
  const { url, isPost, returnAll, ...data } = payload
  const method = isPost ? {} : { _method: 'PATCH' }

  const formData = toDeepFormData({ ...data, ...method })
  const response = await axios.post(url, formData)

  if (response.data.success) {
    const message = success
    store.dispatch(NOTIFICATIONS_INCLUDE, {
      type: 'success',
      message
    })
  } else {
    const message = error
    store.dispatch(NOTIFICATIONS_INCLUDE, new Error(message))
  }

  return (returnAll && response) || response.data.success
}



// WEBPACK FOOTER //
// ./src/helpers/fileUpload.js